"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vuex = require("vuex");

var _eventBus = require("@/helpers/event-bus.js");

var apiAffaire = _interopRequireWildcard(require("@/api/affaire"));

var _moment = _interopRequireDefault(require("moment"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

var _listSecteurGeo = _interopRequireDefault(require("@/components/listSecteurGeo"));

var _listClient = _interopRequireDefault(require("@/components/listClient"));

var _listEnseigne = _interopRequireDefault(require("@/components/listEnseigne"));

var _listCascaderUtilisateur = _interopRequireDefault(require("@/components/listCascaderUtilisateur"));

var _DelaiPaiementSelectList = _interopRequireDefault(require("@/components/DelaiPaiementSelectList"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'InfosAffaireTop',
  components: {
    listSecteurGeo: _listSecteurGeo.default,
    listClient: _listClient.default,
    listEnseigne: _listEnseigne.default,
    listCascaderUtilisateur: _listCascaderUtilisateur.default,
    DelaiPaiementSelectList: _DelaiPaiementSelectList.default
  },
  data: function data() {
    return {
      selection: {},
      formData: {},
      refresh: 0,
      spanCol1: 9,
      spanCol2: 15,
      CONST: CONST,
      editNOM: false,
      editSECTGEO: false,
      editCLIENT: false,
      editENSEIGNE: false,
      editING: false,
      editCDP: false,
      editCDT: false,
      editRSECT: false,
      editDelaiPaiement: false
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              /*
              await this.$store.dispatch('affaire/calcul', { params: null, filtreProvisions: null })
                .then(() => {
                  this.formData.id_secteur_geo = this.affaire.affaire.id_secteur_geo
                  this.formData.id_client = this.affaire.affaire.id_client
                  this.formData.id_enseigne = this.affaire.affaire.id_enseigne
                  this.formData.delai_paiement = this.affaire.affaire.delai_paiement
                  this.refresh++
                })
              */

              /*
              this.formData.id_secteur_geo = this.affaire.affaire.id_secteur_geo
              this.formData.id_client = this.affaire.affaire.id_client
              this.formData.id_enseigne = this.affaire.affaire.id_enseigne
              this.formData.delai_paiement = this.affaire.affaire.delai_paiement
              this.refresh++
              */
              _eventBus.EventBus.$on('REFRESH', function () {
                _this.refresh++;
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['workflow', 'user']), {
    affaire: function affaire() {
      return this.$store.getters.affaire;
    },
    dureeTravaux: function dureeTravaux() {
      var start = (0, _moment.default)(this.affaire.affaire.date_debut_travaux, 'YYYY-MM-DD');
      var end = (0, _moment.default)(this.affaire.affaire.date_fin_travaux, 'YYYY-MM-DD');
      var range = Math.ceil(end.diff(start, 'day') / 7);

      if (isNaN(range)) {
        return '';
      } else {
        return range + (range > 1 ? ' semaines' : ' semaine');
      }
    }
  }),
  methods: {
    isDraft: function isDraft() {
      return this.affaire.affaire.status === CONST.AFFAIRE.STATUS.DRAFT.value;
    },
    canEdit: function canEdit() {
      var cond1 = this.affaire.YYYYMM === this.affaire.histoLastGestMens && this.affaire.histoLastGestMens && this.affaire.YYYYMM === this.affaire.lastGestMens;
      var cond2 = [CONST.AFFAIRE.STATUS.CLOSED.value, CONST.AFFAIRE.STATUS.SLEEPING.value, CONST.AFFAIRE.STATUS.ARCHIVED.value].includes(this.affaire.affaire.status);
      return this.affaire.YYYYMM ? cond1 && !cond2 : true;
    },
    // demande de mise en sommeil
    canAskSleeping: function canAskSleeping() {
      var cond = this.affaire.affaire.etape === CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value && this.affaire.affaire.status !== CONST.AFFAIRE.STATUS.ASKSLEEPING.value && this.affaire.affaire.status !== CONST.AFFAIRE.STATUS.ASKWAKEUP.value && this.affaire.affaire.status !== CONST.AFFAIRE.STATUS.SLEEPING.value && this.affaire.affaire.status !== CONST.AFFAIRE.STATUS.CLOSED.value && this.affaire.affaire.status !== CONST.AFFAIRE.STATUS.ARCHIVED.value;
      return cond;
    },
    // demande de réveil
    canAskWakeUp: function canAskWakeUp() {
      var cond = this.affaire.affaire.status === CONST.AFFAIRE.STATUS.SLEEPING.value;
      return cond;
    },
    // demande d'archivage
    canAskArchiving: function canAskArchiving() {
      var cond = this.affaire.affaire.etape === CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value && this.affaire.affaire.status !== CONST.AFFAIRE.STATUS.ASKARCHIVING.value && this.affaire.affaire.status !== CONST.AFFAIRE.STATUS.ARCHIVED.value;
      return cond;
    },
    // Mettre en sommeil affaire
    canSleeping: function canSleeping() {
      var cond = this.affaire.affaire.etape === CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value && this.affaire.affaire.status !== CONST.AFFAIRE.STATUS.SLEEPING.value && this.affaire.affaire.status !== CONST.AFFAIRE.STATUS.CLOSED.value && this.affaire.affaire.status !== CONST.AFFAIRE.STATUS.ARCHIVED.value;
      return cond;
    },
    // Réveil affaire
    canWakeUp: function canWakeUp() {
      var cond = this.affaire.affaire.status === CONST.AFFAIRE.STATUS.ASKWAKEUP.value || this.affaire.affaire.status === CONST.AFFAIRE.STATUS.SLEEPING.value;
      return cond;
    },
    // Archivage affaire
    canArchiving: function canArchiving() {
      var cond = this.affaire.affaire.etape === CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value && this.affaire.affaire.status !== CONST.AFFAIRE.STATUS.ARCHIVED.value;
      return cond;
    },
    // == SECTEUR GEOGRAPHIQUE ==
    handleChangeSECTGEO: function handleChangeSECTGEO() {
      this.editSECTGEO = true;
    },
    handleCancelSECTGEO: function handleCancelSECTGEO() {
      this.formData.id_secteur_geo = this.affaire.affaire.id_secteur_geo;
      this.editSECTGEO = false;
    },
    handleSaveSECTGEO: function handleSaveSECTGEO() {
      var _this2 = this;

      this.$loader(true); // le changement de secteur geographique oblige de reconstruire le numéro d'affaire et des autres infos qui en dépendent
      // il faut donc forcer l'initialisation des variables formData et selection pour passer correctment dans 'workflow/updComptes'
      // on mémorise le nouveau code secteur geographique

      var newSecteurGeo = this.selection.secteurGeo;
      var oldSecteurGeoLibelle = this.affaire.secteurGeo.libelle; // on force dans formData, l'init des données nécessaires au recalcul du n° affaire, code analytique, compte auxiliaire, etc.. (cf store 'workflow/updComptes')

      this.formData.id_secteur_geo = newSecteurGeo.code;
      this.formData.num_chrono = this.affaire.affaire.num_chrono;
      this.formData.code_analytique_ident_ville = this.affaire.affaire.code_analytique_ident_ville;
      this.formData.indice = this.affaire.affaire.indice; // on force dans selection, l'init des données nécessaires au recalcul du n° affaire, code analytique, compte auxiliaire, etc.. (cf store 'workflow/updComptes')

      this.selection = {
        secteurGeo: {},
        secteurAct: {},
        enseigne: {},
        client: {}
      };
      this.selection.secteurGeo.code = newSecteurGeo.code;
      this.selection.secteurAct.code = this.affaire.secteurAct && this.affaire.secteurAct.code ? this.affaire.secteurAct.code : null;
      this.selection.enseigne.code = this.affaire.enseigne && this.affaire.enseigne.code ? this.affaire.enseigne.code : null;
      this.selection.client.libelle = this.affaire.client && this.affaire.client.libelle ? this.affaire.client.libelle : ''; // appel du recalcul du n° d'affaire, code analytique, compte auxiliaire, etc...

      this.$store.dispatch('workflow/updComptes', {
        societeShortname: this.user.societe_shortname,
        formData: this.formData,
        selection: this.selection
      }).then(function () {
        _this2.formData.id_secteur_geo = newSecteurGeo.id;
        _this2.formData.num_chrono = _this2.workflow.numChrono;
        _this2.formData.code_analytique = _this2.workflow.codeAnalytique;
        _this2.formData.compte_auxiliaire = _this2.workflow.compteAuxilaire;
        _this2.formData.num_affaire = _this2.workflow.numAffaire; // on peut maintenant mettre à jour l'affaire en base de données

        apiAffaire.update(_this2.affaire.affaire.id, {
          id_secteur_geo: newSecteurGeo.id,
          num_affaire: _this2.workflow.numAffaire,
          code_analytique: _this2.workflow.codeAnalytique,
          compte_auxiliaire: _this2.workflow.compteAuxilaire
        }).then(function (results) {
          _this2.editSECTGEO = false;

          _this2.$store.dispatch('affaire/getAffaireById', _this2.affaire.affaire.id).then(function () {
            _this2.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this2.affaire.affaire, {
              message: 'Modification du secteur géographique : ' + oldSecteurGeoLibelle + ' remplacé par ' + newSecteurGeo.libelle
            }));

            _this2.$loader(false);

            _this2.refresh++;
          }).catch(function (error) {
            _this2.$loader(false);

            _this2.$message(error);
          });
        });
      });
    },
    // ==== client ==============
    handleChangeCLIENT: function handleChangeCLIENT() {
      this.editCLIENT = true;
    },
    handleCancelCLIENT: function handleCancelCLIENT() {
      this.editCLIENT = false;
    },
    handleSaveCLIENT: function handleSaveCLIENT() {
      var _this3 = this;

      this.$loader(true);
      apiAffaire.update(this.affaire.affaire.id, {
        id_client: Number(this.selection.client.id),
        id_enseigne: null
      }).then(function (results) {
        _this3.formData.id_enseigne = null;
        _this3.editCLIENT = false;

        _this3.$store.dispatch('affaire/getAffaireById', _this3.affaire.affaire.id).then(function () {
          _this3.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this3.affaire.affaire, {
            message: 'Modification du client : ' + _this3.selection.client.libelle
          }));

          _this3.$loader(false);
        });
      }).catch(function (error) {
        _this3.$loader(false);

        _this3.$message(error);
      });
    },
    // ==== nom affaire ==============
    handleChangeNOM: function handleChangeNOM() {
      this.editNOM = true;
    },
    handleCancelNOM: function handleCancelNOM() {
      this.editNOM = false;
    },
    handleSaveNOM: function handleSaveNOM() {
      var _this4 = this;

      this.$loader(true);
      apiAffaire.update(this.affaire.affaire.id, {
        nom: this.affaire.affaire.nom
      }).then(function (results) {
        _this4.editNOM = false;

        _this4.$store.dispatch('affaire/getAffaireById', _this4.affaire.affaire.id).then(function () {
          _this4.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this4.affaire.affaire, {
            message: 'Modification du nom de l\'affaire : ' + _this4.affaire.nom
          }));

          _this4.$loader(false);
        });
      }).catch(function (error) {
        _this4.$loader(false);

        _this4.$message(error);
      });
    },
    // ==== enseigne ==============
    handleChangeENSEIGNE: function handleChangeENSEIGNE() {
      this.editENSEIGNE = true;
    },
    handleCancelENSEIGNE: function handleCancelENSEIGNE() {
      this.editENSEIGNE = false;
    },
    handleSaveENSEIGNE: function handleSaveENSEIGNE() {
      var _this5 = this;

      this.$loader(true);
      apiAffaire.update(this.affaire.affaire.id, {
        id_enseigne: Number(this.selection.enseigne.id)
      }).then(function (results) {
        _this5.editENSEIGNE = false;

        _this5.$store.dispatch('affaire/getAffaireById', _this5.affaire.affaire.id).then(function () {
          _this5.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this5.affaire.affaire, {
            message: 'Modification de l\'enseigne : ' + _this5.affaire.enseigne.libelle
          }));

          _this5.$loader(false);
        });
      }).catch(function (error) {
        _this5.$loader(false);

        _this5.$message(error);
      });
    },
    // ==== ingénieur d'étude ==============
    handleChangeING: function handleChangeING() {
      this.editING = true;
    },
    handleCancelING: function handleCancelING() {
      this.editING = false;
    },
    handleSaveING: function handleSaveING() {
      var _this6 = this;

      this.$loader(true);
      apiAffaire.update(this.affaire.affaire.id, {
        id_ingenieur_etude: this.affaire.affaire.id_ingenieur_etude
      }).then(function (results) {
        _this6.editING = false;

        _this6.$store.dispatch('affaire/getAffaireById', _this6.affaire.affaire.id).then(function () {
          var ingenieurEtude = _this6.affaire.ingenieurEtude ? _this6.affaire.ingenieurEtude.firstname + ' ' + _this6.affaire.ingenieurEtude.lastname : '';

          if (ingenieurEtude !== '') {
            _this6.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this6.affaire.affaire, {
              message: 'Modification de l\'ingénieur d\'étude : ' + ingenieurEtude
            }));
          }

          _this6.$loader(false);
        });
      }).catch(function (error) {
        _this6.$loader(false);

        _this6.$message(error);
      });
    },
    // ==== chef de projet ==============
    handleChangeCDP: function handleChangeCDP() {
      this.editCDP = true;
    },
    handleCancelCDP: function handleCancelCDP() {
      this.editCDP = false;
    },
    handleSaveCDP: function handleSaveCDP() {
      var _this7 = this;

      this.$loader(true);
      apiAffaire.update(this.affaire.affaire.id, {
        id_chef_projet: this.affaire.affaire.id_chef_projet
      }).then(function (results) {
        _this7.editCDP = false;

        _this7.$store.dispatch('affaire/getAffaireById', _this7.affaire.affaire.id).then(function () {
          var chefProjet = _this7.affaire.chefProjet ? _this7.affaire.chefProjet.firstname + ' ' + _this7.affaire.chefProjet.lastname : '';

          if (chefProjet !== '') {
            _this7.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this7.affaire.affaire, {
              message: 'Modification du chef de projet : ' + chefProjet
            }));
          }

          _this7.$loader(false);
        });
      }).catch(function (error) {
        _this7.$loader(false);

        _this7.$message(error);
      });
    },
    // ==== conducteur de travaux ==============
    handleChangeCDT: function handleChangeCDT() {
      this.editCDT = true;
    },
    handleCancelCDT: function handleCancelCDT() {
      this.editCDT = false;
    },
    handleSaveCDT: function handleSaveCDT() {
      var _this8 = this;

      this.$loader(true);
      apiAffaire.update(this.affaire.affaire.id, {
        id_conducteur_travaux: this.affaire.affaire.id_conducteur_travaux
      }).then(function (results) {
        _this8.editCDT = false;

        _this8.$store.dispatch('affaire/getAffaireById', _this8.affaire.affaire.id).then(function () {
          var conducteurTravaux = _this8.affaire.conducteurTravaux ? _this8.affaire.conducteurTravaux.firstname + ' ' + _this8.affaire.conducteurTravaux.lastname : '';

          if (conducteurTravaux !== '') {
            _this8.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this8.affaire.affaire, {
              message: 'Modification du conducteur de travaux : ' + conducteurTravaux
            }));
          }

          _this8.$loader(false);
        });
      }).catch(function (error) {
        _this8.$loader(false);

        _this8.$message(error);
      });
    },
    // ==== responsable de secteur ==============
    handleChangeRSECT: function handleChangeRSECT() {
      this.editRSECT = true;
    },
    handleCancelRSECT: function handleCancelRSECT() {
      this.editRSECT = false;
    },
    handleSaveRSECT: function handleSaveRSECT() {
      var _this9 = this;

      this.$loader(true);
      apiAffaire.update(this.affaire.affaire.id, {
        id_responsable_secteur: this.affaire.affaire.id_responsable_secteur
      }).then(function (results) {
        _this9.editRSECT = false;

        _this9.$store.dispatch('affaire/getAffaireById', _this9.affaire.affaire.id).then(function () {
          var responsableSecteur = _this9.affaire.responsableSecteur ? _this9.affaire.responsableSecteur.firstname + ' ' + _this9.affaire.responsableSecteur.lastname : '';

          if (responsableSecteur !== '') {
            _this9.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this9.affaire.affaire, {
              message: 'Modification du responsable de secteur : ' + responsableSecteur
            }));
          }

          _this9.$loader(false);
        });
      }).catch(function (error) {
        _this9.$loader(false);

        _this9.$message(error);
      });
    },
    // ==== délai de paiement ==============
    handleChangeDelaiPaiement: function handleChangeDelaiPaiement() {
      this.editDelaiPaiement = true;
    },
    handleCancelDelaiPaiement: function handleCancelDelaiPaiement() {
      this.editDelaiPaiement = false;
      this.formData.delai_paiement = this.affaire.affaire.delai_paiement;
    },
    handleSaveDelaiPaiement: function handleSaveDelaiPaiement() {
      var _this10 = this;

      this.$loader(true);
      apiAffaire.update(this.affaire.affaire.id, {
        delai_paiement: this.formData.delai_paiement
      }).then(function (results) {
        _this10.affaire.affaire.delai_paiement = _this10.formData.delai_paiement;
        _this10.editDelaiPaiement = false;

        _this10.$store.dispatch('affaire/getAffaireById', _this10.affaire.affaire.id).then(function () {
          var delaiPaiement = _this10.affaire.affaire.delai_paiement;

          _this10.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this10.affaire.affaire, {
            message: 'Modification du délai de paiement: ' + delaiPaiement
          }));

          _this10.$loader(false);
        });
      }).catch(function (error) {
        _this10.$loader(false);

        _this10.$message(error);
      });
    },
    // =======================================
    handleOpen: function handleOpen() {
      var _this11 = this;

      this.$confirm('Voulez-vous rouvrir cette affaire ?', 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(function () {
        var data = {
          status: CONST.AFFAIRE.STATUS.DRAFT.value,
          etape: CONST.AFFAIRE.ETAPE.AFFAIRE.value
        };
        apiAffaire.update(_this11.affaire.affaire.id, data).then(function (results) {
          if (results.affectedRows > 0) {
            _this11.affaire.affaire.status = data.status;
            _this11.affaire.affaire.etape = data.etape;

            _this11.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this11.affaire.affaire, {
              message: 'Affaire rouverte ' + _this11.affaire.affaire.num_affaire
            }));

            _this11.$confirm('Affaire rouverte avec succès et placée au status de brouillon. Voulez-vous accèder aux données de cette affaire ?', '', {
              confirmButtonText: 'Oui',
              cancelButtonText: 'Non',
              type: 'success'
            }).then(function () {
              _this11.$router.push('/affaire/edit/' + _this11.affaire.affaire.id);
            });
          }
        });
      });
    },
    // ----
    handleClosed: function handleClosed() {
      var _this12 = this;

      this.$prompt('Entrez le motif de la clôture<br>L\'affaire ne sera plus éditable après votre confirmation.', 'Voulez-vous clôturer cette affaire ?', {
        confirmButtonText: 'OK',
        dangerouslyUseHTMLString: true,
        cancelButtonText: 'Annuler',
        inputPattern: /^\s*\S+.*/,
        inputErrorMessage: 'Champ obligatoire',
        type: 'warning',
        inputType: 'textarea'
      }).then(function (_ref) {
        var value = _ref.value;
        var data = {
          status: CONST.AFFAIRE.STATUS.CLOSED.value,
          etape: CONST.AFFAIRE.ETAPE.AFFAIRE.value
        };
        apiAffaire.update(_this12.affaire.affaire.id, data).then(function (results) {
          if (results.affectedRows > 0) {
            _this12.affaire.affaire.status = data.status;
            _this12.affaire.affaire.etape = data.etape;

            _this12.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this12.affaire.affaire, {
              message: 'Affaire clôturée. Motif: ' + value
            }));

            _eventBus.EventBus.$emit('REFRESH_ROUTER');
          }
        });
      });
    },
    // ----
    isSleepingPossible: function isSleepingPossible() {
      var _this13 = this;

      return new Promise(function (resolve) {
        var message = "\n          La mise en sommeil n'est possible que si :<br>\n          \u2022 Total g\xE9n\xE9ral des provisions = 0<br>\n          \u2022 % Avancement global = 100% ou 0%<br>\n          \u2022 Total g\xE9n\xE9ral engag\xE9 = 0<br>\n          \u2022 Date d'ouverture de chantier renseign\xE9e<br>\n          \u2022 Date de r\xE9ception renseign\xE9e";
        var cond = _this13.affaire.calculs.affaire && _this13.affaire.calculs.affaire.mtTotalGeneralProvisionsRisques === 0 && (_this13.affaire.calculs.affaire.pcAvancementGlobal >= 1 || _this13.affaire.calculs.affaire.pcAvancementGlobal === 0) && _this13.affaire.calculs.affaire.mtTotalGeneralEngage === 0 && _this13.affaire.affaire.date_ouverture_chantier !== null && _this13.affaire.affaire.date_reception !== null;
        /*
        console.log(
          'isSleepingPossible',
          this.affaire.calculs.affaire,
          'mtTotalGeneralProvisions = ' + this.affaire.calculs.affaire.mtTotalGeneralProvisions,
          'mtTotalGeneralProvisionsRisques = ' + this.affaire.calculs.affaire.mtTotalGeneralProvisionsRisques,
          'pcAvancementGlobal = ' + this.affaire.calculs.affaire.pcAvancementGlobal,
          'mtTotalGeneralEngage = ' + this.affaire.calculs.affaire.mtTotalGeneralEngage,
          'date_ouverture_chantier = ' + this.affaire.affaire.date_ouverture_chantier,
          'date_reception = ' + this.affaire.affaire.date_reception
        )
        */

        if (!cond) {
          _this13.$confirm(message, 'Mise en sommeil impossible', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Annuler',
            type: 'error',
            dangerouslyUseHTMLString: true
          }).then(function () {
            throw new Error('Mise en sommeil impossible');
          });
        } else {
          resolve();
        }
      });
    },
    isArchivingPossible: function isArchivingPossible() {
      var _this14 = this;

      return new Promise(function (resolve) {
        var message = "\n          L'archivage n'est possible que si :<br>\n          \u2022 Total g\xE9n\xE9ral des provisions = 0<br>\n          \u2022 % Avancement global = 100% ou 0%<br>\n          \u2022 Total g\xE9n\xE9ral engag\xE9 = 0<br>\n          \u2022 Date d'ouverture de chantier renseign\xE9e<br>\n          \u2022 Date de r\xE9ception renseign\xE9e";
        var cond = _this14.affaire.calculs.affaire && _this14.affaire.calculs.affaire.mtTotalGeneralProvisionsRisques === 0 && (_this14.affaire.calculs.affaire.pcAvancementGlobal >= 1 || _this14.affaire.calculs.affaire.pcAvancementGlobal === 0) && _this14.affaire.calculs.affaire.mtTotalGeneralEngage === 0 && _this14.affaire.affaire.date_ouverture_chantier !== null && _this14.affaire.affaire.date_reception !== null;
        /*
        console.log(
          'isArchivingPossible',
          this.affaire.calculs.affaire,
          'mtTotalGeneralProvisions = ' + this.affaire.calculs.affaire.mtTotalGeneralProvisions,
          'mtTotalGeneralProvisionsRisques = ' + this.affaire.calculs.affaire.mtTotalGeneralProvisionsRisques,
          'pcAvancementGlobal = ' + this.affaire.calculs.affaire.pcAvancementGlobal,
          'mtTotalGeneralEngage = ' + this.affaire.calculs.affaire.mtTotalGeneralEngage,
          'date_ouverture_chantier = ' + this.affaire.affaire.date_ouverture_chantier,
          'date_reception = ' + this.affaire.affaire.date_reception
        )
        */

        if (!cond) {
          _this14.$confirm(message, 'Archivage impossible', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Annuler',
            type: 'error',
            dangerouslyUseHTMLString: true
          }).then(function () {
            throw new Error('Archivage impossible');
          });
        } else {
          resolve();
        }
      });
    },
    handleSleeping: function handleSleeping() {
      var _this15 = this;

      this.isSleepingPossible().then(function () {
        _this15.$confirm('Voulez-vous mettre en sommeil cette affaire ?', 'Confirmation', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(function () {
          var data = {
            status: CONST.AFFAIRE.STATUS.SLEEPING.value,
            etape: CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value
          };
          apiAffaire.update(_this15.affaire.affaire.id, data).then(function (results) {
            if (results.affectedRows > 0) {
              _this15.affaire.affaire.status = data.status;
              _this15.affaire.affaire.etape = data.etape;

              _this15.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this15.affaire.affaire, {
                message: 'Mise en sommeil de l\'affaire'
              }));

              _eventBus.EventBus.$emit('REFRESH_ROUTER'); // pour recharger la page et réactualiser les données du store

            }
          });
        });
      });
    },
    handleArchiving: function handleArchiving() {
      var _this16 = this;

      this.isArchivingPossible().then(function () {
        _this16.$confirm('Voulez-vous archiver cette affaire ?<br>Plus aucune modification ne sera possible sur cette affaire après votre confirmation.', 'Confirmation', {
          confirmButtonText: 'OK',
          dangerouslyUseHTMLString: true,
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(function () {
          var data = {
            status: CONST.AFFAIRE.STATUS.ARCHIVED.value,
            etape: CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value
          };
          apiAffaire.update(_this16.affaire.affaire.id, data).then(function (results) {
            if (results.affectedRows > 0) {
              _this16.affaire.affaire.status = data.status;
              _this16.affaire.affaire.etape = data.etape;

              _this16.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this16.affaire.affaire, {
                message: 'Archivage de l\'affaire'
              }));

              _eventBus.EventBus.$emit('REFRESH_ROUTER'); // pour recharger la page et réactualiser les données du store

            }
          });
        });
      });
    },
    handleWakeUp: function handleWakeUp() {
      var _this17 = this;

      this.$confirm('Voulez-vous réveiller cette affaire ?', 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(function () {
        var data = {
          status: CONST.AFFAIRE.STATUS.CREATED.value,
          etape: CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value
        };
        apiAffaire.update(_this17.affaire.affaire.id, data).then(function (results) {
          if (results.affectedRows > 0) {
            _this17.affaire.affaire.status = data.status;
            _this17.affaire.affaire.etape = data.etape;

            _this17.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this17.affaire.affaire, {
              message: 'Réveil de l\'affaire'
            }));

            _eventBus.EventBus.$emit('REFRESH_ROUTER'); // pour recharger la page et réactualiser les données du store

          }
        });
      });
    },
    handleAskSleeping: function handleAskSleeping() {
      var _this18 = this;

      this.$confirm('Voulez-vous demander la mise en sommeil de cette affaire ?', 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(function () {
        var data = {
          status: CONST.AFFAIRE.STATUS.ASKSLEEPING.value,
          etape: CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value
        };
        apiAffaire.update(_this18.affaire.affaire.id, data).then(function (results) {
          if (results.affectedRows > 0) {
            _this18.affaire.affaire.status = data.status;
            _this18.affaire.affaire.etape = data.etape;

            _this18.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this18.affaire.affaire, {
              message: 'Demande de mise en sommeil de l\'affaire'
            }));

            _eventBus.EventBus.$emit('REFRESH_ROUTER'); // pour recharger la page et réactualiser les données du store

          }
        });
      });
    },
    handleAskWakeUp: function handleAskWakeUp() {
      var _this19 = this;

      this.$confirm('Voulez-vous demander le réveil de cette affaire ?', 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(function () {
        var data = {
          status: CONST.AFFAIRE.STATUS.ASKWAKEUP.value,
          etape: CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value
        };
        apiAffaire.update(_this19.affaire.affaire.id, data).then(function (results) {
          if (results.affectedRows > 0) {
            _this19.affaire.affaire.status = data.status;
            _this19.affaire.affaire.etape = data.etape;

            _this19.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this19.affaire.affaire, {
              message: 'Demande de réveil de l\'affaire'
            }));

            _eventBus.EventBus.$emit('REFRESH_ROUTER'); // pour recharger la page et réactualiser les données du store

          }
        });
      });
    },
    handleAskArchiving: function handleAskArchiving() {
      var _this20 = this;

      this.$confirm('Voulez-vous demander l\'archivage de cette affaire ?', 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(function () {
        var data = {
          status: CONST.AFFAIRE.STATUS.ASKARCHIVING.value,
          etape: CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value
        };
        apiAffaire.update(_this20.affaire.affaire.id, data).then(function (results) {
          if (results.affectedRows > 0) {
            _this20.affaire.affaire.status = data.status;
            _this20.affaire.affaire.etape = data.etape;

            _this20.$store.dispatch('affaire/setHistorique', _objectSpread({}, _this20.affaire.affaire, {
              message: 'Demande d\'archivage de l\'affaire'
            }));

            _eventBus.EventBus.$emit('REFRESH_ROUTER'); // pour recharger la page et réactualiser les données du store

          }
        });
      });
    },
    // --------------------------------
    handleDuplicate: function handleDuplicate() {
      var _this21 = this;

      this.$confirm('Voulez-vous réellement dupliquer de cette affaire ?', 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(function () {
        apiAffaire.duplicate(_this21.affaire.affaire.id).then(function (results) {
          if (results && results.id > 0) {
            _this21.$store.dispatch('affaire/setHistorique', _objectSpread({}, results, {
              message: 'Affaire dupliquée à partir de l\'affaire: ' + _this21.affaire.affaire.num_affaire
            }));

            _this21.$confirm('Affaire dupliquée avec succès et placée au status de brouillon. Voulez-vous accèder aux données de cette nouvelle affaire ?', '', {
              confirmButtonText: 'Oui',
              cancelButtonText: 'Non',
              type: 'success'
            }).then(function () {
              _this21.$router.push('/affaire/edit/' + results.id);
            });
          }
        });
      });
    },
    // ---------------------------------
    handleDelete: function handleDelete() {
      var _this22 = this;

      this.$confirm('Voulez-vous supprimer définitivement cette affaire ? (attention suppression irréversible)', 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(function () {
        apiAffaire.remove(_this22.affaire.affaire.id).then(function (error) {
          if (error.length > 1) {
            _this22.$message.error('Une erreur s\'est produite pendant la suppression de cette affaire');
          } else {
            _this22.$message({
              message: 'Affaire supprimée avec succès.',
              type: 'success'
            });
          }
        }).then(function () {
          _this22.$router.push('/affaire/list');
        });
      });
    }
  }
};
exports.default = _default;